export default {
  props: {
    folderNames: {
      type: Array,
      default: []
    }
  },
  data() {
    return {
      isMenuDisplayed: false
    };
  }
};
